export const IVA = 15
export const MINIMUM_PURCHASE_VALUE = 300
export const POLITICS_VALUE_PURCHASE_ON_PROFORMA = `Recuerde que la empresa procesa pedidos mínimos de US$ ${MINIMUM_PURCHASE_VALUE}`
export const POLITICS_VALUE_PURCHASE_MESSAGE_ON_CART = `Su pedido no cumple con el mínimo de compra establecido por la empresa (US$ ${MINIMUM_PURCHASE_VALUE})`
